import { createSelector } from '@reduxjs/toolkit';
import {RootState} from "../../../../types";

const mySelector = (state: RootState) => state.jobs;

export const selectJobs = createSelector(
    mySelector,
    jobs => jobs?.jobs,
);

export const selectIsLoading = createSelector(
    mySelector,
    jobs => jobs?.isLoading,
);

export const selectJobsByTab = createSelector(
    mySelector,
    jobs => jobs?.jobsByTab || {},
);

export const selectJobsForTab = (tabKey: string) => createSelector(
    mySelector,
    jobs => jobs?.jobsByTab?.[tabKey] || null,
);

export const selectLoadingByTab = createSelector(
    mySelector,
    jobs => jobs?.loadingByTab || {},
);

export const selectIsTabLoading = (tabKey: string) => createSelector(
    mySelector,
    jobs => jobs?.loadingByTab?.[tabKey] || false,
);

export const selectLastFetchByTab = createSelector(
    mySelector,
    jobs => jobs?.lastFetchByTab || {},
);

// New selectors for Recent Jobs Sidepanel
export const selectIsPanelOpen = createSelector(
    mySelector,
    jobs => jobs?.isPanelOpen,
);

export const selectSelectedTab = createSelector(
    mySelector,
    jobs => jobs?.selectedTab,
);

export const selectSearchQuery = createSelector(
    mySelector,
    jobs => jobs?.searchQuery,
);

export const selectIsPolling = createSelector(
    mySelector,
    jobs => jobs?.isPolling,
);